import { generateTextbox } from "../../components/Markup/MarkupFunction";
import reduxStore from "../../configureEnvStore";
import { SHAPE_TYPE, shapeStatus } from "../../constants/Constants";
import { MOUSE_EVENTS, uploadMarkupRootScope } from "../../constants/MarkupConstants";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import navigatorService from "../navigatorService";
import UploadFileMarkupService from "./UploadFileMarkupService";

class TextService {
    textAddInCanvas = (type, o) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (type === MOUSE_EVENTS.DOWN) {
            UploadFileMarkupService.newLineAdded = false;
            UploadFileMarkupService.isMovingText = false;
            console.log("text mouse down");
            if (o.target == null || (o.target && o.target.localShape == false)) {
                //required to set
                uploadMarkupRootScope.isResetted = false;
                uploadMarkupRootScope.escape = false;

                let pointer = annCanvas.getPointer(o.e);
                const textBoxFeatures = {
                    startX: pointer.x,
                    startY: pointer.y,
                    color: UPLOAD_FILES_DATA.selectedImageObj.anncolor,
                    isShadowAndStroke: reduxStore.getState().markup.isShadowOrStroke,
                    fontSize: reduxStore.getState().markup.selectedFontSizeForShape,
                    defaultText: UploadFileMarkupService.markupVar.MarkupDefaultText,
                    shapeType: SHAPE_TYPE.TEXT,
                };
                UploadFileMarkupService.textbox = generateTextbox(textBoxFeatures);
                let dateTime = new Date();
                const currTimeStamp = dateTime.getTime();
                UploadFileMarkupService.textbox.set("id", currTimeStamp);
                UploadFileMarkupService.textbox.set("localShape", true);

                annCanvas.add(UploadFileMarkupService.textbox).setActiveObject(UploadFileMarkupService.textbox);
                UploadFileMarkupService.textbox.enterEditing();
                if (navigatorService.isLatestAndroidChrome()) {
                    //add for latest android chrome only
                    UploadFileMarkupService.textbox.hiddenTextarea.blur();
                    setTimeout(function () {
                        UploadFileMarkupService.textbox.hiddenTextarea.focus();
                    }, 500);
                }
                UploadFileMarkupService.textbox.selectAll();
            }
        } else if (type === MOUSE_EVENTS.UP) {
            let txt = annCanvas.getActiveObject();
            if (txt != null && txt.shape_type != SHAPE_TYPE.TEXT) {
                return;
            }
            //send message on move obj & turn of mouse move on up.
            if (UploadFileMarkupService.isMovingText) {
                UploadFileMarkupService.changeMarkupShapeList(txt);
                UploadFileMarkupService.isMovingText = false;
                UploadFileMarkupService.addShapeCountLog(shapeStatus.MOVE);
            }
        }
    };
}

export default new TextService();
